"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagQA = function FlagQA(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-2.32,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H-2.32Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54-122H-59.1a1.71,1.71,0,0,1,.55.09l42.71,13a1.89,1.89,0,0,1,0,3.61L-52.91-94a1.89,1.89,0,0,0,0,3.61L-15.84-79a1.88,1.88,0,0,1,0,3.6L-52.91-64.15a1.88,1.88,0,0,0,0,3.6l37.07,11.33a1.89,1.89,0,0,1,0,3.61L-52.9-34.33a1.88,1.88,0,0,0,0,3.6l37.06,11.28a1.89,1.89,0,0,1,0,3.61L-52.91-4.51a1.88,1.88,0,0,0,0,3.6l37.07,11.29a1.88,1.88,0,0,1,0,3.6L-52.91,25.31a1.88,1.88,0,0,0,0,3.6L-15.84,40.2a1.88,1.88,0,0,1,0,3.6L-52.91,55.14a1.88,1.88,0,0,0,0,3.6L-15.84,70a1.88,1.88,0,0,1,0,3.6L-52.91,85a1.88,1.88,0,0,0,0,3.6l37.05,11.29a1.88,1.88,0,0,1,0,3.6l-37,11.28a1.89,1.89,0,0,0,0,3.61l37.07,11.33a1.88,1.88,0,0,1,0,3.6l-42.71,13a1.7,1.7,0,0,1-.55.08H209.54a7.06,7.06,0,0,0,7.06-7.06V-114.94a7.06,7.06,0,0,0-7.06-7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#873250"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagQA;
exports["default"] = _default;